import { StepperModal } from 'src/common/components/stepper-modal/stepper-modal';
import styled from 'styled-components';
export const StyledStepperModal = styled(StepperModal)`
  overflow-y: auto;
  @media screen and (min-width: ${({
  theme
}) => theme.sizes.md}) {
    height: 63rem;
  }

  [data-radix-popper-content-wrapper] {
    height: 100%;
    & > div {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
`;